import jwtDecode from "jwt-decode";

export function decodeOriginCustomerIdFromJwt(jwt: string) {
  try {
    const token = jwtDecode(jwt);
    if (token["sub"]) {
      const subList = token["sub"].split("|");
      return subList.length >= 3 ? subList[2] : null;
    }
  } catch (error) {
    console.error("unable to decode jwt", error);
  }
  return null;
}

// TODO: better place to put this?
export function isLocalEnvironment() {
  return ["local", "dev"].includes(window.oetal.env.name);
}
